// Single source of truth for the backend API base URL (always ends in `/api`).
//
// Precedence:
//  1. Explicit build/start-time `REACT_APP_API_BASE_URL` (Vite injects it via
//     `define`; loadEnv also layers a matching shell env var over `.env`). Use
//     this to point at an arbitrary backend; it wins over everything below.
//  2. GitHub Codespaces: each forwarded port is exposed as
//     `<name>-<port>.app.github.dev`. The frontend runs on `-3000`, the backend
//     on `-8000`, so we derive the backend origin from the current frontend
//     origin at runtime — no codespace name is hardcoded, so any codespace works.
//  3. Same-origin `<origin>/api` fallback for single-origin deployments.
//
// `loc` is injectable for testing; defaults to the live `window.location`.
export function resolveApiBaseUrl(
  loc = typeof window !== 'undefined' ? window.location : undefined,
) {
  if (process.env.REACT_APP_API_BASE_URL) return process.env.REACT_APP_API_BASE_URL;
  if (!loc) return 'http://localhost:8000/api'; // SSR / non-browser (e.g. tests)

  if (/-3000\.app\.github\.dev$/.test(loc.hostname)) {
    return `${loc.origin.replace('-3000.app.github.dev', '-8000.app.github.dev')}/api`;
  }

  return `${loc.origin}/api`;
}
